import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { Button, Form, message, Modal, Radio } from 'antd';
import { Loader } from '../Loader/Loader';
import close from '../../assets/RoundedClose.svg';
import { useUpdateIncumbentMutation } from '../../api/tenders';
import { tenderDataProps } from '../../pages/TenderViewPage/types';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<number | null>>;
    tenderData: tenderDataProps;
    setTrigger: Dispatch<SetStateAction<boolean>>;
    supplier: any;
}

export const IncumbentModal: FC<ModalProps> = ({ openModal, setOpenModal, tenderData, setTrigger, supplier }) => {
    const [form] = Form.useForm();

    const [updateIncumbent, { data, isSuccess, isLoading }] = useUpdateIncumbentMutation();

    useEffect(() => {
        if (isSuccess) {
            message?.success(data?.message);
            setOpenModal(null);
            setTrigger((prev) => !prev);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (supplier) {
            console.log('supplier', supplier);
            form.setFieldsValue({
                incumbent:
                    supplier?.incumbent === true ? 'incumbent' : supplier?.incumbent === false ? 'no_incumbent' : ''
            });
        }
    }, [supplier]);

    const handleFormSubmit = async () => {
        form.validateFields()
            .then((res) => {
                console.log(res);
                const dataToPost = {
                    tender_id: tenderData?.id,
                    invite_id: supplier?.id,
                    data: {
                        value: res.incumbent === 'incumbent' ? true : false
                    }
                };
                console.log('dataToPost', dataToPost);
                updateIncumbent(dataToPost);
            })
            .catch((err) => err);
    };

    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onCancel={() => {
                    setOpenModal(null);
                }}
                closeIcon={<img src={close} />}
                footer={
                    <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                        <Button block key="back" onClick={() => setOpenModal(null)} className="cancel">
                            Cancel
                        </Button>
                        <Button block key="submit" type="primary" onClick={handleFormSubmit}>
                            {isLoading ? <Loader /> : 'Save'}
                        </Button>
                    </div>
                }
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">{supplier?.company?.name}</div>
                    </div>

                    <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                        <div className="main__title">Please, select the incumbent status for this supplier</div>
                        <Form form={form}>
                            <Form.Item
                                className="input-wrapper"
                                name="incumbent"
                                rules={[{ required: true, message: 'Please select an option' }]}
                            >
                                <Radio.Group style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                    <Radio value="incumbent">
                                        <div className="checkbox_text">Incumbent Participation</div>
                                    </Radio>

                                    <Radio value="no_incumbent">
                                        <div className="checkbox_text">No Incumbent Participation</div>
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Modal>
        </>
    );
};
